import { X } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { SolidButton } from "./SolidButton";
import "react-datepicker/dist/react-datepicker.css";

export const MyCalModel = ({ onClose, onApply, onReset, isOpen ,onChange}) => {
  // const [dateRange, setDateRange] = useState(["", "");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const setDateRange = (update) => {
    const [start, end] = update;
    setStartDate(start);
    setEndDate(end);
  };

  const calRef = useRef(null); // ✅ ref for popup

  // ✅ click outside logic
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calRef.current && !calRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed top-36 right-10 z-50">
      <div
        ref={calRef} // ✅ attach here
        className="relative p-4 bg-white/90 dark:bg-slate-900/90 backdrop-blur-xl rounded-2xl border border-slate-200/50 dark:border-slate-700/50 shadow-xl"
      >
        <DatePicker
          // selected={startDate}
          showPopperArrow={false}
          shouldCloseOnSelect={false}
          onChange={(update) => {
            const [start, end] = update || [];

            const startDateFixed = start
              ? new Date(
                  start.getFullYear(),
                  start.getMonth(),
                  start.getDate(),
                  0,
                  0,
                  0,
                  0,
                )
              : null;

            const endDateFixed = end
              ? new Date(
                  end.getFullYear(),
                  end.getMonth(),
                  end.getDate(),
                  23,
                  59,
                  59,
                  999,
                )
              : null;

            setDateRange([startDateFixed, endDateFixed]);

            console.log("fromDate", startDateFixed?.toISOString());
            console.log("toDate", endDateFixed?.toISOString());
            onChange(startDateFixed,endDateFixed);
          }}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          inline
          maxDate={new Date()}
          monthsShown={2}
          calendarClassName="  !shadow-xl !bg-slate-200 dark:!bg-slate-600 !flex"
        />
        <div className="flex items-center justify-center space-x-4 mt-4">
          <button
            className="px-4 py-2 rounded-lg text-xs
                              bg-slate-400/20 dark:bg-slate-800 
                              text-slate-800 dark:text-slate-300  font-semibold
                              hover:bg-slate-400/30 dark:hover:bg-slate-700 
                              transition-all duration-300 ml-auto"
            onClick={() => {
              setDateRange(["", ""]);
              onChange(null,null);
              onReset();

              
            }}
          >
            Clear
          </button>
          <SolidButton
            children={<span className="text-xs">Apply</span>}
            onClick={() => {
              //     applyFilter();
              onApply();
              onClose();
            }}
          />
        </div>
      </div>
    </div>
  );
};
